import { UserInfo } from 'models';
import React, { Fragment, useEffect } from 'react';
import {
  EditPreferencePath,
  ManageOutagesPath,
  MarketplaceApprovalsPath,
  ViewOrderPath,
} from 'utils/routes';
import { useOnBehalf } from 'hooks';
import { RootState } from 'redux/store';
import { useSelector } from 'react-redux';

export const NOT_ALLOWED_ROUTES = [
  EditPreferencePath,
  ManageOutagesPath,
  MarketplaceApprovalsPath,
  ViewOrderPath,
];

const OnBehalfContainer = ({ children }: { children: JSX.Element }) => {
  const {
    onDispatchOnBehalfUser,
    onEndOnBehalf,
    onGetUserDetailByEmail,
    storageData,
  } = useOnBehalf();

  const { generalConfig } = useSelector(
    (state: RootState) => state.configReducer,
  );

  useEffect(() => {
    if (!storageData.enabled || !storageData.email) {
      onEndOnBehalf();
      return;
    }

    (async () => {
      try {
        if(!generalConfig?.uptimeApimServices) return;
        
        const { data: responseData, hasUser } =  await onGetUserDetailByEmail(
          storageData.email,
          !!storageData.isNewjoiner,
          !!storageData.isLeaver
        );
        const userInfo: UserInfo | null = (hasUser && responseData) || null;
        onDispatchOnBehalfUser({
          userOnBehalf: userInfo as UserInfo,
          isOnBehalf: storageData.enabled,
          isOnBehalfNewJoiner: !!storageData.isNewjoiner,
          isOnBehalfLeaver: !!storageData.isLeaver,
          isManager: !!storageData.isManager,
        });
      } catch (error) {
        console.error(error);
      }
    })();
  }, [generalConfig?.uptimeApimServices]);

  return <Fragment>{children}</Fragment>;
};

export default OnBehalfContainer;
